export const ADD_QUESTIONSCATEGORY_REQUEST = 'ADD_QUESTIONSCATEGORY_REQUEST'
export const ADD_QUESTIONSCATEGORY_SUCCESS = 'ADD_QUESTIONSCATEGORY_SUCCESS'
export const ADD_QUESTIONSCATEGORY_FAILURE = 'ADD_QUESTIONSCATEGORY_FAILURE'
export const ADD_QUESTIONSCATEGORY_UPDATE = 'ADD_QUESTIONSCATEGORY_UPDATE'

